<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-settings-area"
      :title="$t(getTitleModal)"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="lg"
    >
      <div class="scroll-kanban">
        <ValidationObserver ref="form-settings-homework-status">
          <div>
            <b-row class="border-right">
              <!-- Name -->
              <b-col md="12">
                <b-form-group :label="$t('Name')">
                  <ValidationProvider
                    #default="{ errors }"
                    name="name"
                    rules="required"
                  >
                    <b-form-input
                      :class="{ 'border-danger rounded': errors[0] }"
                      v-model="form.name"
                      type="text"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col sm="10">
                <b-form-group :label="$t('Roles')">
                  <ValidationProvider #default="{ errors }" name="rol">
                    <v-select
                      v-model="rolSelected"
                      :options="roles"
                      :state="errors[0] ? null : false"
                      :reduce="(val) => val.id"
                      label="name"
                      class="w-100"
                    ></v-select>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group label="' '">
                  <b-button variant="outline-success w-100" @click="addItemRol">
                    <feather-icon icon="PlusIcon" class="text-success" />
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <h4 class="mt-1 mb-1" v-t="'Roles'"></h4>
            <b-row>
              <b-col>
                <div class="overflow-auto" style="height: 300px">
                  <div
                    v-for="rol in form.rolesArea"
                    :key="rol.rol_id"
                    class="mt-1 border-bottom row justify-content-between overflow-auto"
                  >
                    <div class="ml-2 mr-2">
                      <b-avatar size="25px" rounded variant="light-warning">
                        <feather-icon
                          icon="MinusSquareIcon"
                          class="text-warning"
                        />
                      </b-avatar>
                      <span class="mr-1" style="margin-left: 5px">
                        {{ rol.code.toUpperCase() }}
                      </span>
                      -
                      <span class="ml-1">
                        {{ rol.name | capitalize }}
                      </span>
                    </div>
                    <feather-icon
                      icon="DeleteIcon"
                      size="20"
                      class="text-danger mr-2 cursor-pointer"
                      @click="deleteItem(rol)"
                    />
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </ValidationObserver>
      </div>
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button variant="outline-primary" @click="saveArea">
                {{ $t("Save") }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* Service */
import RolesAreaService from "@/views/settings/views/roles-area/service/roles-area.service.js";

export default {
  components: {},
  props: {
    areaId: {
      required: true,
    },
  },
  data() {
    return {
      items: [],
      form: {
        id: null,
        name: null,
        rolesArea: [],
      },
      roles: [],
      rolSelected: null,
    };
  },
  mounted() {
    this.toggleModal("modal-settings-area");
  },
  async created() {
    this.form.id = this.areaId;
    try {
      this.addPreloader();
      await Promise.all([this.getDataAreaById(), this.getRoles()]);
    } catch (error) {
    } finally {
      this.removePreloader();
    }
  },
  computed: {
    getTitleModal() {
      if (this.areaId !== null) {
        return "EDIT AREA";
      }
      return "NEW AREA";
    },
  },
  methods: {
    async getDataAreaById() {
      if (this.areaId == null) return;
      try {
        const { data } = await RolesAreaService.getDataAreaById({
          id: this.areaId,
        });
        this.form.name = data[0].name;
        this.form.rolesArea = data[0].roles;
      } catch (error) {
        console.log(error);
      }
    },
    async getRoles() {
      try {
        const { data } = await RolesAreaService.getRolesForSelect();
        this.roles = data;
      } catch (error) {
        console.log(error);
      }
    },

    deleteItem(rol) {
      this.form.rolesArea = this.form.rolesArea.filter(
        (item) => item.rol_id !== rol.rol_id
      );
    },
    async saveArea() {
      try {
        this.addPreloader();
        const params = {
          id: this.form.id,
          name: this.form.name,
          roles: JSON.stringify(this.form.rolesArea),
        };
        const { data } = await RolesAreaService.saveArea(params);
        this.showToastSuccess(data.message);
        this.$emit("refreshTable");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data);
      } finally {
        this.removePreloader();
      }
    },

    addItemRol() {
      if (this.rolSelected == null) return;
      if (this.form.rolesArea.find((item) => item.rol_id == this.rolSelected)) {
        this.showToastWarning("Rol already registered");
        return;
      }
      const rol = this.roles.find((it) => it.id == this.rolSelected);
      this.form.rolesArea.push({
        rol_id: rol.id,
        code: rol.code,
        name: rol.name,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>